import { z } from "zod"

export const ProjectHistoryEntryActionSchema = z.enum([
  "CREATE",
  "UPDATE",
  "DELETE",
  "MOVE_IN",
  "MOVE_OUT"
])

export const ProjectHistoryEntityTypeSchema = z.enum([
  "Project",
  "ProductPosition",
  "Room",
  "Floor"
])

const ProjectHistoryEntryChangeSchema = z.object({
  field: z.string(),
  newValue: z.unknown(),
  oldValue: z.unknown()
})

const ProjectHistoryEntryMoveSchema = z.object({
  fromEntityType: z.string(),
  fromEntityId: z.string(),
  toEntityType: z.string(),
  toEntityId: z.string()
})

export const ProjectHistoryEntryUserSchema = z.object({
  id: z.string(),
  name: z.string().optional().nullish(),
  email: z.string().optional().nullish()
})

export const ProjectHistoryProductVariantSchema = z.object({
  type: z.literal("ProductPosition"),
  id: z.string(),
  displayPosition: z.string().optional().nullish(),
  variantKey: z.string().optional().nullish()
})

export const ProjectHistoryRoomSchema = z.object({
  type: z.literal("Room"),
  id: z.string(),
  label: z.string().optional().nullish(),
  number: z.string().optional().nullish()
})

export const ProjectHistoryFloorSchema = z.object({
  type: z.literal("Floor"),
  id: z.string(),
  label: z.string().optional().nullish()
})

export const ProjectHistoryProjectSchema = z.object({
  id: z.string(),
  title: z.string().optional().nullish(),
  type: z.literal("Project")
})

export const ProjectHistoryEntitySchema = z.union([
  ProjectHistoryProductVariantSchema,
  ProjectHistoryRoomSchema,
  ProjectHistoryFloorSchema,
  ProjectHistoryProjectSchema
])

export const ProjectHistoryEntrySchema = z.object({
  id: z.string(),
  action: ProjectHistoryEntryActionSchema,
  entityType: ProjectHistoryEntityTypeSchema,
  label: z.string().optional().nullish(),
  changes: z.array(ProjectHistoryEntryChangeSchema).optional().nullish(),
  entity: ProjectHistoryEntitySchema.optional().nullish(),
  toEntity: ProjectHistoryEntitySchema.optional().nullish(),
  fromEntity: ProjectHistoryEntitySchema.optional().nullish(),
  user: ProjectHistoryEntryUserSchema.optional().nullish(),
  project: ProjectHistoryProjectSchema,
  timestamp: z.string(),
  move: ProjectHistoryEntryMoveSchema.optional().nullish()
})

export type ProjectHistoryEntry = z.infer<typeof ProjectHistoryEntrySchema>
